import { is } from '@didi/webx-js'
import { pagePath } from '@/common/jump'

export const resourceNames = is('miniprogram')
  ? 'didi_applets_plane_ticket_home_page'
  : 'didipas_plane_ticket_home_page'

export const flightsFallingConf = {
  pagePath: pagePath()?.HOME,
  themeConf: {
    panel: {
      headerImage:
        'https://ut-static.udache.com/webx/sfc/-NDKy9E81eNNSBCj_9Ylg.png',
    },
    button: {
      text: '立即领取',
      textColor: '#ff4200',
      backgroundColor: 'linear-gradient(181deg, #FFF6DD 1%, #FFECAB 219%)',
    },
    coupon: {
      amountColor: '#FF591D',
      unitColor: '#F5420D',
      nameColor: '#290700',
      remarkColor: '#B69786',
      couponBg:
        'linear-gradient(159deg, #FFFFFF 16%, rgba(255, 255, 255, 0.3492) 67%), linear-gradient(279deg, #FFEBD6 1%, #FFF8F0 94%)',
    },
  },
  params: {
    // 90004 为火车票的 business_id, 但本次准星要求传入 256 (公共业务线)
    business_id: 256,
    channel_id: 1100000001,
    resource_names: resourceNames,
  },
}

